import React from "react";
import { ArrowRightStartOnRectangleIcon } from "@heroicons/react/24/solid";
import { PlusIcon } from "@heroicons/react/24/outline";

const Table = ({
  title,
  headers,
  data,
  received,
  renderRow,
  EditingProducts,
  addCart,
  setShowForm,
  onAddProduct,
  searchBox,
  setSearchBox,
  cartIsOutCart,
}) => {
  // console.log(EditingProducts)
  return (
    <div className={`${EditingProducts ? "" : "relative"} mx-auto rounded-xl`}>
      {title && (
        <div className="flex justify-between mx-4 my-3">
          <h1 className="text-xl font-bold text-black">{title}</h1>
          <div className="flex gap-5">
            {received && cartIsOutCart && (
              <>
                <button
                  className="flex items-center gap-3 px-3 py-2 duration-300 rounded-lg bg-custom-yellow hover:bg-black group"
                  onClick={onAddProduct}
                >
                  <PlusIcon className="w-6 h-6 text-black group-hover:text-white" />
                  <span className="text-black group-hover:text-white">
                    Product
                  </span>
                </button>
              </>
            )}
            {EditingProducts && (
              <button
                onClick={() => EditingProducts(true)}
                className="px-2 py-2 duration-300 rounded-full bg-custom-yellow hover:bg-yellow-600"
              >
                <ArrowRightStartOnRectangleIcon class="h-6 w-6 text-black" />
              </button>
            )}
          </div>

          {addCart && (
            <>
              <div className="flex items-center gap-3">
                <input
                  type="text"
                  placeholder="Search by Box No"
                  value={searchBox}
                  onChange={(e) => setSearchBox(e.target.value)}
                  className="px-2 py-2 text-black bg-white border placeholder:text-black"
                />
                <button
                  className="flex items-center gap-3 px-3 py-2 duration-300 bg-custom-yellow hover:bg-black group"
                  onClick={() => setShowForm(true)}
                >
                  <PlusIcon className="w-6 h-6 text-black group-hover:text-white" />
                  <span className="text-black group-hover:text-white">
                    Cart
                  </span>
                </button>
              </div>
            </>
          )}
          {!addCart && !EditingProducts && (
            <>
              <div className="flex items-center gap-3">
                <input
                  type="text"
                  placeholder="Search by Box No"
                  value={searchBox}
                  onChange={(e) => setSearchBox(e.target.value)}
                  className="px-2 py-2 text-black bg-white border placeholder:text-black"
                />
              </div>
            </>
          )}
        </div>
      )}
      <table className="w-full">
        <thead>
          <tr className="text-sm text-black bg-custom-yellow">
            {headers.map((header, index) => (
              <th key={index} className="px-2 py-2 font-bold text-center">
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>{data.map((item, index) => renderRow(item, index))}</tbody>
      </table>
    </div>
  );
};

export default Table;
